import React, { FC } from 'react'
import { useHistory } from 'react-router-dom'
import { MyProfileButton, ProfileButtonWrapper, ChevronRight, LeftIcon } from './ProfileButton.style'

interface Props {
    title: string
    route: string
    icon: string
    showChevron?: boolean
    last?: boolean
    onButtonClick?: () => void
}

const ProfileButton: FC<Props> = ({ title, route, icon, showChevron = true, last = false, onButtonClick }) => {
    const history = useHistory()

    return (
        <MyProfileButton
            key={title}
            $withMargin={showChevron}
            $borderBottom={last}
            onClick={() => {
                if (onButtonClick) {
                    onButtonClick()
                } else {
                    history.push(route)
                }
            }}
        >
            <ProfileButtonWrapper>
                <LeftIcon className={icon} />
                <span>{title}</span>
            </ProfileButtonWrapper>
            {showChevron && <ChevronRight className="wemolo-chevron-right" />}
        </MyProfileButton>
    )
}

export default ProfileButton
